import * as React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';
import InputField from '@components/form/input';
import Flex from '@components/layout/flex';
interface DistributeOwnershipDistributionProps {
  className?: string;
  owner: any;
  locked?: boolean;
  managerSplit: number;
  updateCurrentSplit: (newSplit: number, ownerId: string) => void;
}
const DistributeOwnershipRowCtrl: React.FC<
  DistributeOwnershipDistributionProps
> = (props) => {
  const [splitFocus, setSplitFocus] = React.useState(false);
  const handleChangeCondition = (value: string) => {
    let valueMatch: number | undefined;
    const updatedValue = value.split('%')[0];
    if (updatedValue) {
      valueMatch = updatedValue.match(/\./g)?.length;
    } else {
      valueMatch = 0;
    }

    return (
      (!updatedValue || (updatedValue && Number(updatedValue) <= 100)) &&
      (!valueMatch || valueMatch <= 1) &&
      (!updatedValue ||
        !originalSplit ||
        (originalSplit.length === 1 &&
        originalSplit === '0' &&
        updatedValue.split('')[0] === '0'
          ? updatedValue.split('')[1] === '.'
          : updatedValue.split('.').length > 1
          ? updatedValue.split('.')[1].length <= 2
          : true))
    );
  };
  const getSplitValue = () => {
    if (props.owner.removed) {
      return String(props.managerSplit.toFixed(2));
    }
    if (props.owner.split) {
      return String(props.owner.split.toFixed(2));
    }

    return splitFocus ? '' : '0';
  };
  const [originalSplit, setOriginalSplit] = React.useState(getSplitValue());
  React.useEffect(() => {
    if (props.owner.removed) {
      setOriginalSplit(String(props.managerSplit.toFixed(2)));
    } else {
      if (props.owner.split) {
        setOriginalSplit(String(props.owner.split.toFixed(2)));
      } else {
        setOriginalSplit(String(0));
      }
    }
  }, [props.owner, props.managerSplit]);
  return (
    <OwnershipRowCtrlContainer className={`${props.className} mb-10`}>
      <Flex>
        <InputField
          style={{
            width: props.owner.removed ? '50%' : '75%',
          }}
          className="input-split"
          label={
            <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.INPUT.STACKSHOLDER_NAME" />
          }
          value={props.owner.fullName}
          redValue={props.owner.removed}
          locked={true}
          hasClose={false}
          customBorderRadius={props.owner.removed ? '4px 0 0 0' : '4px 0 0 4px'}
        />
        <InputField
          style={{
            width: '25%',
            minWidth: '66px',
          }}
          className="input-split"
          label={
            <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.INPUT.SPLIT" />
          }
          // TODO: DEVTEAM-958 - Add an '%' symbol at the end of the value.
          value={`${originalSplit}%`}
          onChange={(value) => {
            if (handleChangeCondition(value)) {
              setOriginalSplit(value.split('%')[0]);
              props.updateCurrentSplit(
                Number(value.split('%')[0]),
                props.owner.pk
              );
            }
          }}
          onFocus={() => setSplitFocus(true)}
          onBlur={() => setSplitFocus(false)}
          locked={props.locked || props.owner.removed}
          customBorderRadius={props.owner.removed ? '4px 0 0 0' : '4px 0 0 4px'}
        />
        {props.owner.removed && (
          <InputField
            style={{ width: '25%' }}
            className="input-split"
            label={
              <Translate id="RELEASE.TRACK_INFO.TRACK.OWNERSHIP.INPUT.NEW_SPLIT" />
            }
            // TODO: DEVTEAM-958 - Add an '%' symbol at the end of the value.
            value={'0.00%'}
            onFocus={() => setSplitFocus(true)}
            onBlur={() => setSplitFocus(false)}
            locked={true}
            redValue={props.owner.removed}
            customBorderRadius={
              props.owner.removed ? '4px 0 0 0' : '4px 0 0 4px'
            }
            // TODO: DEVTEAM-831 - yellowValue integration need to be reviewed. This is just for demo.
          />
        )}
      </Flex>
    </OwnershipRowCtrlContainer>
  );
};
export default DistributeOwnershipRowCtrl;
const OwnershipRowCtrlContainer = styled.div`
  position: relative;

  &:first-child {
    margin-top: 10px;
    ${({ theme }) => `@media screen and ${theme.device.laptopXL}`} {
      margin-top: 20px;
    }
  }

  .handle-icon {
    z-index: 9;
  }

  .input-wrapper {
    position: relative;

    & > * {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 35%;

      &:first-child {
        flex-basis: 65%;
      }

      ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
        flex-basis: 30%;

        &:first-child {
          flex-basis: 70%;
        }
      }
    }
  }
`;
